import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { cart } from '../lib/cart.js'
import { aud, optionUnit } from '../lib/format.js'
import { GST_RATE } from '../data/site.js'
import { focusStyle } from '../lib/imageFocus.js'
import Icon from '../components/Icon.jsx'

export default function CartPage() {
  const [items, setItems] = useState(cart.get())
  const navigate = useNavigate()
  useEffect(() => cart.subscribe(setItems), [])

  const subtotal = cart.subtotal()
  const gst = subtotal * GST_RATE

  if (!items.length) {
    return (
      <main className="container page">
        <header className="page-head">
          <h1>Your cart</h1>
        </header>
        <div className="empty-state">
          <Icon name="cart" size={44} stroke={1.4} />
          <p>Your cart is empty.</p>
          <Link to="/shop" className="btn btn-primary">Browse products</Link>
        </div>
      </main>
    )
  }

  return (
    <main className="container page">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>Cart</span></nav>
      <header className="page-head"><h1>Your cart</h1></header>
      <div className="cart-layout">
        <div className="cart-list">
          {items.map((it) => (
            <article key={it.id} className="cart-item">
              <div className="cart-item-media">
                {it.image ? <img src={it.image} alt="" style={focusStyle(it.image)} /> : <span className="cart-item-noimg"><Icon name="glass" size={22} /></span>}
              </div>
              <div className="cart-item-body">
                <h3>{it.name}</h3>
                {Object.keys(it.opts || {}).length > 0 && (
                  <p className="cart-item-opts">
                    {Object.entries(it.opts).map(([k, v]) => `${k.replace(/\s*\(mm\)/, '')}: ${v}${optionUnit(k, v)}`).join(' · ')}
                  </p>
                )}
                <p className="cart-item-unit">{aud(it.unitPrice)} each</p>
              </div>
              <div className="cart-item-actions">
                <div className="qty-input qty-input-sm">
                  <button onClick={() => cart.setQty(it.id, it.qty - 1)} aria-label="Decrease">−</button>
                  <span>{it.qty}</span>
                  <button onClick={() => cart.setQty(it.id, it.qty + 1)} aria-label="Increase">+</button>
                </div>
                <strong>{aud(it.unitPrice * it.qty)}</strong>
                <button className="link-danger" onClick={() => cart.remove(it.id)}>Remove</button>
              </div>
            </article>
          ))}
        </div>
        <aside className="cart-summary">
          <h2>Order summary</h2>
          <dl>
            <div><dt>Subtotal (ex GST)</dt><dd>{aud(subtotal)}</dd></div>
            <div><dt>GST (10%)</dt><dd>{aud(gst)}</dd></div>
            <div><dt>Shipping</dt><dd>calculated at checkout</dd></div>
            <div className="total"><dt>Total (inc GST)</dt><dd>{aud(subtotal + gst)}</dd></div>
          </dl>
          <button className="btn btn-primary btn-lg btn-block" onClick={() => navigate('/checkout')}>
            Checkout <Icon name="arrowRight" size={17} />
          </button>
          <Link to="/shop" className="btn btn-outline btn-block">Continue shopping</Link>
          <p className="summary-note"><Icon name="shield" size={14} /> Pay securely by card (Stripe) or direct bank transfer.</p>
        </aside>
      </div>
    </main>
  )
}
